module.exports = __webpack_public_path__ + "img/pg2-title-sub2-inner.ccf8ce93.png";